// Keep in sync with backend/migrations (Categories).
export const CATEGORIES = [
  'Oberteile',
  'Hosen',
  'Kleider & Röcke',
  'Jacken',
  'Schuhe',
  'Accessoires',
  'Sonstiges',
] as const;

export type Category = (typeof CATEGORIES)[number];

export type Priority = 1 | 2 | 3;

export const PRIORITY_LABELS: Record<Priority, string> = {
  1: 'Muss her',
  2: 'Wäre schön',
  3: 'Irgendwann',
};

export const DEFAULT_CURRENCY = 'EUR';
